<template>
  <div>
    <panel class="announcement" v-if="loading">
      <loader :loading="loading"/>
    </panel>
    <panel :title="title" :withFooter="false" v-else>
      <div slot="header-right" v-if="!product">
        <span>Este anúncio precisa ser migrado</span>
        <button class="btn btn--info" @click="redirectToMigration()">Migrar</button>
      </div>

      <div class="l-row">
        <panel class="blue-panel" title="Variações">
          <div class="l-col-12@md" v-if="product">
            <announcement-match-variation
              v-for="announcementVariation in product.variations"
              :key="announcementVariation"
              :announcementVariation="announcementVariation"
              :product="product"
              :account="account"
            />
            <span>Não há mais Matchs disponíveis</span>
          </div>
        </panel>
      </div>
    </panel>
  </div>
</template>

<script>
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import AnnouncementMatchVariation from '@/components/marketplace/mercadoLivre/match/Variation'

  export default {
    data: () => ({
      loading: false,
      show: true,
      product: null,
      details: null,
      withBody: false,
      isLoading: false,
      title: null
    }),
    props: {
      account: {
        type: String,
        required: true
      },
      announcement: {
        type: String,
        required: true
      }
    },
    async mounted () {
      try {
        this.title = this.announcement
        this.loading = true
        this.product = await api.mercadoLivre.retrieveByCode(this.announcement, this.account)
        this.title = `${this.announcement} - ${this.product.title}`
      } catch (e) {
        // previne fatal error
      } finally {
        this.loading = false
      }
    },
    methods: {
      redirectToMigration () {
        this.$router.push('/marketplace/mercadoLivre/announcements/migration')
      }
    },
    watch: {
    },
    components: {
      Panel,
      Loader,
      FormGroup,
      Multiselect,
      AnnouncementMatchVariation
    }
  }
</script>

<style lang="sass" scoped>
  .announcement
    min-height: 80px

  .photo
    max-width: 80%
    margin: 0 auto

  .no-photo
    font-size: 140px
    color: #a9a9a9
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px

  .partial
    background: #FFA500
    color: #fff
</style>



// WEBPACK FOOTER //
// AnnouncementMatchCard.vue?64a14f8c